import { render, staticRenderFns } from "./NursingCard.vue?vue&type=template&id=3514895f&scoped=true"
import script from "./NursingCard.vue?vue&type=script&lang=js"
export * from "./NursingCard.vue?vue&type=script&lang=js"
import style0 from "./NursingCard.vue?vue&type=style&index=0&id=3514895f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3514895f",
  null
  
)

export default component.exports